import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import { useNavigate } from 'react-router-dom';
import LoginIcon from '@mui/icons-material/Login';


export default function Forbidden() {

    const goToLogin = () => {
        navigate("/login")
    }

    const navigate = useNavigate()

    return (

        <>
             <Container component="main" maxWidth="xs">
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <div className="login">
                            <p align="center">
                                <i className="pi pi-ban" style={{ color: 'red', fontSize: '2rem' }}></i>
                                <p>¡Atención!</p>
                                <p>No tenes permisos para ver esta página</p>
                                <p><Button endIcon={<LoginIcon />} type="submit" variant="outlined" color="success" onClick={goToLogin}>
                                    Login 
                                </Button></p>
                            </p>
                        </div>
                    </Grid>
                </Grid >
            </Container>
        </>
    )

}